/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable no-param-reassign */
/* eslint-disable no-restricted-globals */
/* eslint-disable prefer-template */
/* eslint-disable no-else-return */
const CPF_LENGTH = 11;
const CNPJ_LENGTH = 14;

export interface IDefaultReturn {
  masked: string;
  unmasked: string;
}

const defaultReturn = (masked: string, unmasked: string): IDefaultReturn => ({
  masked,
  unmasked,
});

export const verificationCodeMask = (value: string) => {
  return value.replace(/\D/g, '').replace(/^(\d{3})(\d{1,3})/g, '$1 $2');
};

export const verificationCodeUnmask = (value: string) => value.replace(' ', '');

export const currencyMask = (param: number | string): string => {
  if (!param) return '0,00';

  let value = '';

  if (typeof param === 'number') {
    param = param.toFixed(2);
  }

  if (String(param).includes('.') || String(param).includes(',')) {
    value = String(param);
  } else {
    value = `${String(param)}.00`;
  }

  value = String(value).replace('.', '').replace(',', '');

  const v = `${(Number(value) / 100).toFixed(2)}`.split('.');

  const m = v[0]
    .split('')
    .reverse()
    .join('')
    .match(/.{1,3}/g);

  for (let i = 0; i < m.length; i += 1)
    m[i] = `${m[i].split('').reverse().join('')}.`;

  const r = m.reverse().join('');

  const masked = `${r.substring(0, r.lastIndexOf('.'))},${v[1]}`;

  return masked;
};

export const currencyNegativeAndPositiveMask = (param: number | string): string => {
  if (!param && param !== 0) return '0,00';

  let isNegative = false;
  let value = param;

  // Detecta sinal negativo
  if (typeof value === 'string') {
    if (value.includes('-')) isNegative = true;
    value = value.replace(/[^0-9.,]/g, '');
  }

  if (typeof value === 'number') {
    if (value < 0) isNegative = true;
    value = Math.abs(value).toFixed(2);
  }

  if (String(value).includes('.') || String(value).includes(',')) {
    value = String(value);
  } else {
    value = `${String(value)}.00`;
  }

  value = String(value).replace('.', '').replace(',', '');

  const v = `${(Number(value) / 100).toFixed(2)}`.split('.');

  const m = v[0]
    .split('')
    .reverse()
    .join('')
    .match(/.{1,3}/g);

  for (let i = 0; i < m.length; i += 1)
    m[i] = `${m[i].split('').reverse().join('')}.`;

  const r = m.reverse().join('');

  const masked = `${r.substring(0, r.lastIndexOf('.'))},${v[1]}`;

  // ➤ Recoloca o sinal negativo no início
  return isNegative ? `-${masked}` : masked;
};

export const formatCurrency = (value) => {
  const numeric = value.replace(/\D/g, '')

  if (!numeric) return '0,00';

  const intValue = parseInt(numeric, 10);
  let formatted = (intValue / 100).toFixed(2);

  formatted = formatted
      .replace('.', ',')
      .replace(/\B(?=(\d{3})+(?!\d))/g, '.');

    return formatted;
}

export const creditCardUnmask = (value = ''): string =>
  value.replace('.', '').replace('.', '').replace('.', '').replace('.', '');

export const dateUnmask = (value = ''): string => value.replace(/\D/gim, '');

export const cepUnmask = (value = ''): string => value.replace(/\D/gim, '');

export const cpfUnmask = (value = ''): string => value.replace(/\D/gim, '');

export const cnpjUnmask = (value = ''): string => value.replace(/\D/g, '');

export const currencyUnmasked = (value = ''): number =>
  Number(value.replace('.', '').replace(',', '.'));

export const phoneUnmask = (value = ''): string =>
  value.replace(/\D/gim, '').replace(/\D/g, '');

export const cpfMask = (value = ''): IDefaultReturn => {
  const maskedValue = value
    .replace(/\D/g, '')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d{1,2})/, '$1-$2')
    .replace(/(-\d{2})\d+?$/, '$1');

  return defaultReturn(maskedValue, cpfUnmask(value));
};

export const cnpjMask = (value = ''): IDefaultReturn => {
  const maskedValue = value
    .replace(/\D/g, '')
    .replace(/(\d{2})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1/$2')
    .replace(/(\d{4})(\d{1,2})/, '$1-$2')
    .replace(/(-\d{2})\d+?$/, '$1');

  return defaultReturn(maskedValue, cnpjUnmask(value));
};

export const cnpjExtendedMask = (value = ''): IDefaultReturn => {
  const digits = value.replace(/\D/g, '').slice(0, 17);
  const cnpjDigits = digits.slice(0, 14);
  const suffix = digits.slice(14);

  const maskedCnpj = cnpjDigits
    .replace(/(\d{2})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1/$2')
    .replace(/(\d{4})(\d{1,2})/, '$1-$2');

  const masked = suffix.length > 0 ? `${maskedCnpj} ${suffix}` : maskedCnpj;

  return defaultReturn(masked, digits);
};

export const creditCardMask = (value = ''): IDefaultReturn => {
  if (!value) return defaultReturn('', '');
  const newValue = value.replace(/\D/g, '');
  const sizeValue = value.length;

  if (sizeValue <= 9)
    return defaultReturn(
      newValue.replace(/(\d{4})(\d{1,4})/g, '$1.$2'),
      creditCardUnmask(value),
    );

  if (sizeValue <= 14)
    return defaultReturn(
      newValue.replace(/(\d{4})(\d{4})(\d{1,4})/g, '$1.$2.$3'),
      creditCardUnmask(value),
    );

  return defaultReturn(
    newValue.replace(/(\d{4})(\d{4})(\d{4})(\d{1,4})/g, '$1.$2.$3.$4'),
    creditCardUnmask(value),
  );
};

export const dateMask = (value = ''): IDefaultReturn => {
  const newValue = value.replace(/\D/g, '').replace(/^(\d{2})(\d)/g, '$1/$2');

  if (newValue.length > 4)
    return defaultReturn(
      newValue.replace(/(\d{2})(\d{1,2})/, '$1/$2'),
      dateUnmask(value),
    );
  return defaultReturn(newValue, dateUnmask(value));
};

export const phoneMask = (value = ''): IDefaultReturn => {
  const maskedValue = value
    .replace(/\D/g, '')
    .replace(/^(\d{2})(\d)/g, '($1) $2')
    .replace(/(\d)(\d{4})$/, '$1-$2');

  return defaultReturn(maskedValue, phoneUnmask(value));
};

export const cepMask = (value = ''): IDefaultReturn => {
  const maskedValue = value
    .replace(/\D/g, '')
    .replace(/^([\d]{2})\.*([\d]{3})-*([\d]{3})/, '$1$2-$3');

  return defaultReturn(maskedValue, cepUnmask(value));
};

export const hourMinSecMask = (value = ''): IDefaultReturn => {
  const maskedValue = value
    .replace(/\D/g, '')
    .replace(/(\d{2})(\d)/, '$1:$2')
    .replace(/(\d{2})(\d{1,2})/, '$1:$2')
    .replace(/(:\d{2})\d+?$/, '$1');

  return defaultReturn(maskedValue, cepUnmask(value));
};

export const hourMinMask = (value = ''): IDefaultReturn => {
  const maskedValue = value
    .replace(/\D/g, '')
    .replace(/(\d{2})(\d)/, '$1:$2')
    .replace(/(:\d{2})\d+?$/, '$1');

  return defaultReturn(maskedValue, cepUnmask(value));
};

export const numericMask = (value = ''): string => value.replace(/\D/g, '');

export const hideEmailMask = (value = ''): string => {
  const [prefix] = value.split('@');

  const prefixToHide = prefix.slice(2);

  return value.replace(prefixToHide, '*'.repeat(prefixToHide.length));
};

export const cpfCnpjMask = (value = ''): IDefaultReturn => {
  const onlyNumbers = value.replace(/\D/g, '').slice(0, CNPJ_LENGTH);

  let maskedValue: string;

  if (onlyNumbers.length <= CPF_LENGTH) {
    maskedValue = onlyNumbers
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d{1,2})/, '$1-$2')
      .replace(/(-\d{2})\d+?$/, '$1');
  } else {
    maskedValue = onlyNumbers
      .replace(/(\d{2})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d{4})/, '$1/$2')
      .replace(/(\d{4})(\d{2})/, '$1-$2')
      .replace(/(-\d{2})\d+?$/, '$1');
  }

  return defaultReturn(maskedValue, onlyNumbers);
};

export const cpfCnpjExtendedMask = (value = ''): IDefaultReturn => {
  const digits = value.replace(/\D/g, '').slice(0, 17);

  if (digits.length <= CPF_LENGTH) {
    const maskedValue = digits
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d{1,2})/, '$1-$2')
      .replace(/(-\d{2})\d+?$/, '$1');
    return defaultReturn(maskedValue, digits);
  }

  const cnpjDigits = digits.slice(0, 14);
  const suffix = digits.slice(14);

  const maskedCnpj = cnpjDigits
    .replace(/(\d{2})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d{4})/, '$1/$2')
    .replace(/(\d{4})(\d{2})/, '$1-$2');

  const masked = suffix.length > 0 ? `${maskedCnpj} ${suffix}` : maskedCnpj;

  return defaultReturn(masked, digits);
};

export const emailMask = (value = ''): string =>
  value
    .replace(/[^a-zA-Z0-9-_.@]/g, '')
    .trim()
    .toLowerCase();

export const nameMask = (value = '') => {
  return value
    .toUpperCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^\w\s]/gi, '')
    .replace(/[0-9]/g, '')
    .replace(/ +(?= )/g, '');
};

export function abbreviateNumber(value: number): string {
  if (value >= 1000000) {
    return (value / 1000000).toFixed(2) + 'MM';
  } else if (value >= 1000) {
    return (value / 1000).toFixed(2) + 'k';
  } else {
    return value.toFixed(2);
  }
}

export const nameFormatter = (value = '') => {
  const split = value.split(' ');

  const formatted = split.map((word) => {
    word = word.replace(/\d/g, '');
    // verifica se input é preposicoes de sobrenomes ('dos, das, de') etc
    if (word.length <= 3) {
      // verifica se a preposicao digitada esta em uppercase, para nomes especificos ('O, Al) etc
      if (word.charAt(0).toUpperCase() === word.charAt(0)) {
        return word;
      }
      return word.toLowerCase();
    }
    return word.charAt(0).toUpperCase() + word.slice(1);
  });
  return formatted.join(' ');
};
